import React, { useCallback } from 'react';
import styles from './PayFabricPaymentsSDK.module.scss';
import { getErrorMessage } from './utils/paymentHelpers';

// interface PayFabricResponse {
//   AVSAddressResponse: string;
//   AVSZipResponse: string;
//   AuthCode: string;
//   CVV2Response: string;
//   CardType: string;
//   ExoneratingText: string;
//   ExpectedSettledTime: string;
//   ExpectedSettledTimeUTC: string;
//   FinalAmount: string;
//   FraudScore: string;
//   IAVSAddressResponse: string;
//   IncriminatingText: string;
//   OrigTrxAmount: string;
//   OriginationID: string;
//   PayFabricErrorCode: string;
//   RemainingBalance: string;
//   RespStatus: string;
//   RespTrxTag: string;
//   ResponseMsg: string;
//   ResultCode: string;
//   ResultStatus: string;
//   SettledTime: string;
//   SettledTimeUTC: string;
//   SurchargeAmount: string;
//   SurchargePercentage: string;
//   TerminalID: string;
//   TerminalResultCode: string;
//   TrxAmount: string;
//   TrxDate: string;
//   TrxDateUTC: string;
//   TrxKey: string;
//   WalletID: string;
//   errorMessage?: string;
// }

const PAYFABRIC_PAYMENTS_SDK_ID = 'payFabricPaymentsSDK';

export default function PayFabricPaymentsSDK(props) {
  const {
    token,
    handleFormLoaded,
    handleCancel,
    handleTransactionCompleted,
    handleTransactionFailed,
    isProduction,
  } = props;

  const loadPaymentsSDK = useCallback(() => {
    try {
      const payFabricPaymentsSDK = document.getElementById(
        PAYFABRIC_PAYMENTS_SDK_ID
      );

      if (payFabricPaymentsSDK) {
        // eslint-disable-next-line no-undef
        new payfabricpayments({
          environment: isProduction ? 'LIVE' : 'SANDBOX',
          target: PAYFABRIC_PAYMENTS_SDK_ID,
          session: token,
          successCallback: (response) => {
            if (handleTransactionCompleted instanceof Function) {
              handleTransactionCompleted(response);
            }
          },
          failureCallback: (response) => {
            if (
              handleTransactionFailed instanceof Function &&
              response.ResultCode === '0'
            ) {
              response.errorMessage = getErrorMessage(response.RespStatus);
              handleTransactionFailed(response);
            }
          },
          cancelCallback: () => {
            if (handleCancel instanceof Function) handleCancel();
          },
          readyCallback: () => {
            if (handleFormLoaded instanceof Function) handleFormLoaded();
          },
          displayMethod: 'IN_PLACE',
          requireShippingAddress: false,
          acceptedPaymentMethods: ['CreditCard', 'ApplePay', 'GooglePay'],
          themeName: 'VitusPayMobile',
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, [
    handleCancel,
    handleFormLoaded,
    handleTransactionCompleted,
    handleTransactionFailed,
    isProduction,
    token,
  ]);

  React.useEffect(() => {
    if (token) {
      const script = document.createElement('script');
      script.src =
        'https://cdn.vitusvet.com/scripts/payfabricpayments.v2.bundle.min.js';
      script.onload = loadPaymentsSDK;
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [token, loadPaymentsSDK]);

  return (
    <div className={styles.container}>
      <div id={PAYFABRIC_PAYMENTS_SDK_ID}></div>
    </div>
  );
}
